import React from 'react'
import { Input, Button,
    Container, Table, Row, Col, Label,
    DropdownItem } from 'reactstrap'
import JobScheduleFlowViewController from './JobScheduleFlowViewController'
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io'
import '../css/QuoteViewController.css'
import SimpleDropdown from '../view/DropDownView'
import CustomDropDownView from '../view/CustomDropDownView'
import NumberTextField from '../view/NumberTextField'
import { Account } from '../model/Account'
import { getQuote } from '../model/request/quotes'
import {
    getSchedule,
    updateSchedule,
    getAssignTo,
    getSortedAssignTo,
} from '../model/request/schedule'
import { getAllScheduleTemplates } from '../model/request/schedule_template'
import { Quote } from '../model/Quote'
import { Schedule, Priority } from '../model/Schedule'
import { TextNormalization } from '../model/TextNormalization'
import TeamDropdown from '../view/TeamDropdown'
import { GenerateSchedules, ScheduleTemplate } from '../model/ScheduleTemplate'
import { evaluate } from 'mathjs'
import dateFormat from 'dateformat'
import { LocalSettings } from '../model/LocalSettings'
import { EQUIPMENT_LIST, EQUIPMENT_PROCESSES } from '../model/Equipment'
import { getAllScheduleMaterialTemplates } from '../model/request/schedule_material_template'

class ProcessSchedulerViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        const account = Account.fromCookieAndLocalStorage()
        this.state = {
            'prev_schedules': [],
            'assigning_dependency_index': -1,
            'schedules': [],
            'templates': [],
            'materialTemplates': [],
            'quote': null,
            'assign_to': [],
            'account': account,
            'pickerThickness': '.02',
            'pickerMaterial': 'Gemini',
            'materialsPickerOpenIdx': -1,
            'pickerThicknessOpen': false,
            'pickerMaterialOpen': false,
            'pickerThicknessIsOther': false,
            'pickerMaterialIsOther': false,
        }
    }

    componentDidMount() {
        this.loadJob()
    }
    
    loadJob() {
        this.props.turnOnLoader(4)

        getAllScheduleTemplates().then(
            (result) => {
                this.setState({ 'templates': result.data.templates.map(ScheduleTemplate.from) })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )

        getAllScheduleMaterialTemplates().then(
            (result) => {
                this.setState({ 'materialTemplates': result.data.templates })
                this.props.turnOffLoader()
            },
            (error) => { this.props.showError(error); this.props.turnOffLoader() }
        )

        getAssignTo().then(
            (result) => {
                this.setState({
                    'assign_to': result.data.assign_to,
                })
            },
            (error) => {
                this.props.showError(error)
            }
        )

        getQuote(this.props.id).then(
            (result) => {
                const quote = Quote.from(result.data.quote)
                quote.signs = quote.signs.filter(s => s.quantity > 0)
                this.setState({ 'quote': quote })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        getSchedule(this.props.id).then(
            (result) => {
                const schedules = []
                const oldSchedules = []
                for (let i = 0; i < result.data.schedules.length; i++) {
                    schedules.push(Schedule.from(result.data.schedules[i]))
                    schedules[i].human_expected_duration_minutes /= 60.0
                    oldSchedules.push(Schedule.from(result.data.schedules[i]))
                }

                if (schedules.length === 0) {
                    schedules.push(new Schedule())
                }

                this.setState({
                    'schedules': schedules,
                    'prev_schedules': oldSchedules,
                })

                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }


    // MARK: Use Loader

    turnOnLoader(by=1) {
        this.setState(function(state, props) {
            return {
                displayLoader: state.displayLoader + by
            }
        })
    }

    turnOffLoader() {
        this.setState(function(state, props) {
            return {
                displayLoader: state.displayLoader - 1
            }
        })
    }


    // MARK: Button Actions

    save() {
        this.props.turnOnLoader()
        let schedules = JSON.parse(JSON.stringify(this.state.schedules))
        for (let i = 0; i < schedules.length; i++) {
            schedules[i].human_expected_duration_minutes = (60. * schedules[i].human_expected_duration_minutes).toFixed(0)
            schedules[i].order_index = i
        }
        updateSchedule(this.state.prev_schedules, schedules, this.props.id).then(
            (failures) => {
                this.loadJob()
                this.props.turnOffLoader()
                if (failures && failures.length > 0) {
                    this.props.showError('Failed to save ' + failures.length + ' task(s). Please review and try again.')
                }
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    evaluateTimeFormula(formula, sign) {
        if (!formula) { 
            return 0
        }

        try {
            return Math.ceil((evaluate(formula, {
                width: parseFloat(sign.width) || 0,
                height: parseFloat(sign.height) || 0,
                quantity: parseFloat(sign.quantity) || 0,
            }) || 0) * 100) / 100
        } catch (e) {
            return 0
        }
    }

    deleteAtRow(index) {
        const deletedDeps = this.state.schedules[index].dependency
        const schedules = this.state.schedules.slice(0, index)
            .concat(this.state.schedules.slice(index + 1))
        schedules.forEach(s => {
            if (s.dependency.indexOf(index) >= 0) {
                s.dependency = [...new Set([...s.dependency, ...deletedDeps])]
            }
            s.dependency = s.dependency
                .filter(d => d !== index)
                .map(d => d > index ? d - 1 : d)
        })
        this.state.schedules = schedules
        this.setState({ 'schedules': schedules })
    }

    swapSchedules(indexA, indexB) {
        const schedules = this.state.schedules
        schedules.forEach(s => {
            s.dependency = s.dependency.map(d => {
                if (d === indexA) return indexB
                if (d === indexB) return indexA
                return d
            })
        })
        const tmp = schedules[indexA]
        schedules[indexA] = schedules[indexB]
        schedules[indexB] = tmp
        this.setState({})
    }

    merge(i, j) {
        if (i > j) {
            return this.merge(j, i)
        }
        if (i == j) {
            return
        }

        let schedules = this.state.schedules

        // merge together
        schedules.forEach(s => {
            s.dependency = s.dependency
                .map(d => {
                    if (d === i) {
                        return j;
                    } else {
                        return d;
                    }
                })
        })
        schedules[j].dependency = [
            ...new Set([...schedules[j].dependency,
                ...schedules[i].dependency]),
        ]
        schedules[j].human_expected_duration_minutes = Math.ceil(
            (schedules[j].human_expected_duration_minutes + schedules[i].human_expected_duration_minutes) * 100
        ) / 100
        schedules[j].sign_ids = [...new Set([
            ...schedules[j].sign_ids,
            ...schedules[i].sign_ids,
        ])]

        const materialKey = (m) => `${m.material}|${m.thickness}`
        const mergedMaterials = new Map()
        ;[...(Array.isArray(schedules[j].materials) ? schedules[j].materials : []),
            ...(Array.isArray(schedules[i].materials) ? schedules[i].materials : [])]
            .forEach(m => mergedMaterials.set(materialKey(m), m))
        schedules[j].materials = [...mergedMaterials.values()]

        this.deleteAtRow(i)
    }

    mergeAll() {
        for (let i = 0; i < this.state.schedules.length; i++) {
            for (let j = i+1; j < this.state.schedules.length; j++) {
                if (this.state.schedules[i].canMerge(this.state.schedules[j])) {
                    this.merge(i, j);
                    i -= 1;
                    break;
                }
            }
        }
        this.sortSchedulesByDependency()
    }

    /**
     * Reorders schedules so every dependency comes before whatever depends on
     * it, using Tarjan's strongly-connected-components algorithm. Any cycle
     * (e.g. tasks of different sign types left mutually dependent after a
     * merge) is automatically kept together as one block by the algorithm
     * itself, so no separate "group by sign type" step is needed.
     */
    sortSchedulesByDependency() {
        const schedules = this.state.schedules
        const n = schedules.length
        let counter = 0
        const idx = new Array(n).fill(-1)
        const low = new Array(n).fill(0)
        const onStack = new Array(n).fill(false)
        const stack = []
        const components = []

        const strongconnect = (v) => {
            idx[v] = low[v] = counter++
            stack.push(v)
            onStack[v] = true
            for (const w of (schedules[v].dependency || [])) {
                if (typeof w !== 'number' || w < 0 || w >= n) continue
                if (idx[w] === -1) {
                    strongconnect(w)
                    low[v] = Math.min(low[v], low[w])
                } else if (onStack[w]) {
                    low[v] = Math.min(low[v], idx[w])
                }
            }
            if (low[v] === idx[v]) {
                const component = []
                let w
                do {
                    w = stack.pop()
                    onStack[w] = false
                    component.push(w)
                } while (w !== v)
                components.push(component.sort((a, b) => a - b))
            }
        }

        for (let v = 0; v < n; v++) {
            if (idx[v] === -1) strongconnect(v)
        }

        const newOrder = components.flat()
        const oldToNew = new Array(n)
        newOrder.forEach((oldIdx, newIdx) => { oldToNew[oldIdx] = newIdx })

        const reordered = newOrder.map(oldIdx => schedules[oldIdx])
        reordered.forEach(s => {
            s.dependency = (s.dependency || [])
                .map(d => (typeof d === 'number' ? oldToNew[d] : d))
                .filter(d => d !== undefined)
        })

        this.state.schedules = reordered
        this.setState({ schedules: reordered })
    }

    /**
     * For display only — does not modify the stored dependency list. If a
     * task directly depends on two things but one of those things already
     * transitively depends on the other, only the "latest" (most immediate)
     * dependency is shown, since it already implies the other one.
     * @param {number} index
     * @return {[number]}
     */
    reducedDependencies(index) {
        const schedules = this.state.schedules
        const deps = (schedules[index].dependency || []).filter(d => typeof d === 'number')

        const reachableFrom = (start) => {
            const seen = new Set()
            const stack = [start]
            while (stack.length > 0) {
                const v = stack.pop()
                for (const w of (schedules[v]?.dependency || [])) {
                    if (typeof w !== 'number' || seen.has(w)) continue
                    seen.add(w)
                    stack.push(w)
                }
            }
            return seen
        }

        return deps.filter(d =>
            !deps.some(other => other !== d && reachableFrom(other).has(d))
        )
    }

    suggest() {
        const sortedSigns = [...this.state.quote.signs].sort((a, b) => a.order_index - b.order_index)
        const rawGenerated = GenerateSchedules(
            Object.assign({}, this.state.quote, { signs: sortedSigns }),
            this.state.templates,
        )
        if (rawGenerated.length === 0) {
            this.props.showError('No templates matched the signs in this quote.')
            return
        }
        rawGenerated.forEach(s => {
            s.materials = (s.thickness || s.material)
                ? [{ material: s.material || '', thickness: s.thickness || '' }]
                : []
        })
        const bySign = {}
        rawGenerated.forEach(s => {
            const key = s.sign_ids && s.sign_ids[0]
            if (!bySign[key]) bySign[key] = []
            bySign[key].push(s)
        })
        const existing = (this.state.schedules.length === 1 && JSON.stringify(this.state.schedules[0]) === JSON.stringify(new Schedule()))
            ? []
            : this.state.schedules

        const generated = []
        for (const sign of sortedSigns) {
            const raw = bySign[sign.id] || []
            const groupIds = new Set(raw.map(s => s.id))
            const inDegree = {}
            const dependents = {}
            raw.forEach(s => {
                inDegree[s.id] = (s.dependency || []).filter(d => groupIds.has(d)).length
                dependents[s.id] = []
            })
            raw.forEach(s => {
                (s.dependency || []).filter(d => groupIds.has(d)).forEach(d => {
                    dependents[d].push(s.id)
                })
            })
            const idToSchedule = Object.fromEntries(raw.map(s => [s.id, s]))
            const queue = raw.filter(s => inDegree[s.id] === 0)
            const group = []
            while (queue.length > 0) {
                const s = queue.shift()
                group.push(s)
                dependents[s.id].forEach(depId => {
                    inDegree[depId]--
                    if (inDegree[depId] === 0) queue.push(idToSchedule[depId])
                })
            }
            let candidates = new Set(group)
            let changed = true
            while (changed) {
                changed = false
                const candidateIds = new Set([...candidates].map(s => s.id))
                for (const s of [...candidates]) {
                    const resolvedDepCount = (s.dependency || []).filter(d => candidateIds.has(d)).length
                    if (resolvedDepCount === 0 && s.dependency.length > 0 && !s.dependency.includes(null)) {
                        candidates.delete(s)
                        changed = true
                    }
                }
            }

            const signIdToIndex = {}
            let offset = 0
            group.forEach(s => {
                if (candidates.has(s)) {
                    if (s.id) signIdToIndex[s.id] = existing.length + generated.length + offset
                    offset++
                }
            })

            group.forEach(s => {
                if (!candidates.has(s)) return
                s.dependency = s.dependency.map(d => signIdToIndex[d]).filter(d => d !== undefined)
                s.id = null
                s.human_expected_duration_minutes = this.evaluateTimeFormula(s.time_formula, sign)
                generated.push(s)
            })
        }

        const allSchedules = [...existing, ...generated]

        const dependentOf = {}
        generated.forEach((s, i) => {
            const absIdx = existing.length + i
            for (const depIdx of s.dependency) {
                if (!dependentOf[depIdx]) dependentOf[depIdx] = []
                dependentOf[depIdx].push(absIdx)
            }
        })

        let anyChange = true
        while (anyChange) {
            anyChange = false
            generated.forEach(s => {
                for (const depIdx of s.dependency) {
                    const dep = allSchedules[depIdx]
                    if (!dep) continue
                    if (!(Array.isArray(s.materials) ? s.materials : []).length && (Array.isArray(dep.materials) ? dep.materials : []).length) { s.materials = dep.materials; anyChange = true }
                }
            })
            generated.forEach((s, i) => {
                if ((Array.isArray(s.materials) ? s.materials : []).length) return
                const absIdx = existing.length + i
                for (const depIdx of (dependentOf[absIdx] || [])) {
                    const dep = allSchedules[depIdx]
                    if (!dep) continue
                    if (!(Array.isArray(s.materials) ? s.materials : []).length && (Array.isArray(dep.materials) ? dep.materials : []).length) { s.materials = dep.materials; anyChange = true }
                }
            })
        }

        const signById = Object.fromEntries(sortedSigns.map(s => [s.id, s]))
        generated.forEach(s => {
            if ((Array.isArray(s.materials) ? s.materials : []).length) return
            const sign = s.sign_ids && s.sign_ids.length > 0 ? signById[s.sign_ids[0]] : null
            if (!sign) return
            const matching = this.state.materialTemplates
                .filter(mt => mt.type_id === sign.type.id && (mt.addons || []).every(entry => {
                    const signAddon = (sign.addons || []).find(a => a.id === entry.addon_id)
                    if (!signAddon) return false
                    return !entry.labels || entry.labels.length === 0
                        || entry.labels.some(l => signAddon.label.includes(l))
                }))
                .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
            const combined = matching.reduce((acc, mt) => {
                if (mt.thickness) acc.thickness = mt.thickness
                if (mt.material) acc.material = mt.material
                return acc
            }, { thickness: '', material: '' })
            if (combined.thickness || combined.material) {
                s.materials = [combined]
            }
        })

        this.setState({ 'schedules': [...existing, ...generated] })
    }

    // MARK: Views

    renderHeader(label) {
        return <Col>
            <Label style={{
                'fontSize': '20pt',
                'fontWeight': '500',
            }}>{label}</Label>
        </Col>
    }

    /**
     * @param {string} title
     * @param {string} value
     * @param {[string]} values
     * @param {function} onClick
     * @param {{normalize: string}} modalOptions forwarded to
     *     `showTextFieldModal` when 'Other' is picked - see its docs.
     */
    renderDropDown(title, value, values, onClick, modalOptions={}) {

        const lastIndex = values.length - 1
        values = [...values]

        let index = values.indexOf(value)
        if (index === -1 && value.length > 0) {
            values.push(value)
            index = values.length - 1
        }

        return <SimpleDropdown
            index={index}
            values={values}
            onChange={(index) => {
                if (index === lastIndex
                    && values[index] === 'Other') {
                    this.props.showTextFieldModal(title, (value) => {
                        onClick(value, index)
                    }, value, modalOptions)
                } else {
                    onClick(values[index], index)
                }
            }} />
    }

    renderMaterialsPicker(schedule, index) {
        const THICKNESS_OPTIONS = ['.02', '.04', '1/32', '1/16', '1/8', '3/16', '1/4', '3/8', '1/2', '3/4', 'Other']
        const MATERIAL_OPTIONS = ['Gemini', 'Non Glare', 'P95', 'White Acrylic', 'White Calsak',
            'Black Acrylic', 'Black Calsak', 'Clear', 'Thermoformed', 'Painted Acrylic',
            'DA Clear', 'DA White', 'Aluminum', 'Mylar', 'Lexan', 'Cardstock',
            'Rowmark', 'Polycarbonate', 'Sintra', 'Other']

        const materials = Array.isArray(schedule.materials) ? schedule.materials : []
        const label = materials.map(m => `${m.thickness} ${m.material}`).join(', ')
        const truncated = label.length > 42 ? label.slice(0, 42) + '…' : label
        const buttonLabel = materials.length === 0 ? '—' : truncated

        const isOpen = this.state.materialsPickerOpenIdx === index
        const toggle = () => this.setState({
            materialsPickerOpenIdx: isOpen ? -1 : index,
            pickerThicknessOpen: false,
            pickerMaterialOpen: false,
        })

        const updateMaterials = (newMaterials) => {
            const schedules = this.state.schedules
            schedules[index].materials = newMaterials
            this.setState({ schedules })
        }

        const addPair = () => {
            updateMaterials([...materials, {
                thickness: this.state.pickerThickness,
                material: this.state.pickerMaterial,
            }])
        }

        const thicknessLabel = this.state.pickerThicknessIsOther ? 'Other' : this.state.pickerThickness
        const materialLabel = this.state.pickerMaterialIsOther ? 'Other' : this.state.pickerMaterial

        const pickerBtnStyle = {
            width: '100%', textAlign: 'left', display: 'flex',
            justifyContent: 'space-between', alignItems: 'center',
        }

        const view = (
            <>
                    {/* Pills */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginBottom: '8px' }}>
                        {materials.map((m, i) => (
                            <span key={i} style={{
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                background: 'var(--bs-secondary)', color: 'white',
                                borderRadius: '12px', padding: '2px 8px', fontSize: '12px',
                            }}>
                                {m.thickness} {m.material}
                                <button
                                    onClick={() => updateMaterials(materials.filter((_, j) => j !== i))}
                                    style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', padding: '0 2px', lineHeight: 1 }}
                                >×</button>
                            </span>
                        ))}
                        {materials.length === 0 && <span style={{ color: 'var(--bs-secondary)', fontSize: '12px' }}>No materials added</span>}
                    </div>

                    {/* Pickers row */}
                    <div style={{ display: 'flex', gap: '30px', alignItems: 'center', marginTop: '8px' }}>
                        {/* Thickness */}
                        <div style={{ position: 'relative', width: '90px', flexShrink: 0 }}>
                            <button className="btn btn-secondary btn-sm dropdown-toggle" style={pickerBtnStyle}
                                onClick={() => this.setState({
                                    pickerThicknessOpen: !this.state.pickerThicknessOpen,
                                    pickerMaterialOpen: false,
                                })}
                            >
                                {thicknessLabel}
                            </button>
                            {this.state.pickerThicknessOpen && (
                                <div className="dropdown-menu show" style={{
                                    position: 'absolute', top: '100%', left: 0,
                                    zIndex: 1055, maxHeight: '200px', overflowY: 'auto', minWidth: '100%',
                                }}>
                                    {THICKNESS_OPTIONS.map(o => (
                                        <button key={o} className="dropdown-item"
                                            onClick={() => {
                                                if (o === 'Other') {
                                                    this.setState({ pickerThicknessIsOther: true, pickerThicknessOpen: false })
                                                } else {
                                                    this.setState({ pickerThickness: o, pickerThicknessIsOther: false, pickerThicknessOpen: false })
                                                }
                                            }}
                                        >{o}</button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Material */}
                        <div style={{ position: 'relative', width: '160px', flexShrink: 0 }}>
                            <button className="btn btn-secondary btn-sm dropdown-toggle" style={pickerBtnStyle}
                                onClick={() => this.setState({
                                    pickerMaterialOpen: !this.state.pickerMaterialOpen,
                                    pickerThicknessOpen: false,
                                })}
                            >
                                {materialLabel}
                            </button>
                            {this.state.pickerMaterialOpen && (
                                <div className="dropdown-menu show" style={{
                                    position: 'absolute', top: '100%', left: 0,
                                    zIndex: 1055, maxHeight: '200px', overflowY: 'auto', minWidth: '100%',
                                }}>
                                    {MATERIAL_OPTIONS.map(o => (
                                        <button key={o} className="dropdown-item"
                                            onClick={() => {
                                                if (o === 'Other') {
                                                    this.setState({ pickerMaterialIsOther: true, pickerMaterialOpen: false })
                                                } else {
                                                    this.setState({ pickerMaterial: o, pickerMaterialIsOther: false, pickerMaterialOpen: false })
                                                }
                                            }}
                                        >{o}</button>
                                    ))}
                                </div>
                            )}
                        </div>

                        <Button size="sm" color="primary" style={{ flexShrink: 0 }}
                            onClick={addPair}
                        >Add</Button>
                    </div>

                    {/* Custom value inputs — own row so they don't affect button alignment */}
                    {(this.state.pickerThicknessIsOther || this.state.pickerMaterialIsOther) && (
                        <div style={{ display: 'flex', gap: '30px', marginTop: '6px' }}>
                            <div style={{ width: '90px', flexShrink: 0 }}>
                                {this.state.pickerThicknessIsOther && (
                                    <Input bsSize="sm" placeholder="Custom thickness…"
                                        value={this.state.pickerThickness}
                                        onChange={e => this.setState({ pickerThickness: e.target.value })}
                                    />
                                )}
                            </div>
                            <div style={{ width: '160px', flexShrink: 0 }}>
                                {this.state.pickerMaterialIsOther && (
                                    <Input bsSize="sm" placeholder="Custom material…"
                                        value={this.state.pickerMaterial}
                                        onChange={e => this.setState({ pickerMaterial: e.target.value })}
                                    />
                                )}
                            </div>
                        </div>
                    )}
            </>
        )

        return (
            <CustomDropDownView
                isOpen={isOpen} toggle={toggle}
                toggleLabel={buttonLabel}
                toggleStyle={{ width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                size="sm" color="secondary"
                menuStyle={{ padding: '8px', minWidth: '340px', overflow: 'visible' }}
                view={view}
            />
        )
    }

    makeRows() {
        if (!this.state.quote) {
            return <></>
        }

        return this.state.schedules.map((schedule, index) =>
            <tr
                className={(this.state.assigning_dependency_index >= 0 &&
                    this.state.schedules[this.state.assigning_dependency_index].hasDependency(index))
                    ? "selected" : ""
                }
                key={"row"+index} onClick={() => {
                if (this.state.assigning_dependency_index >= 0 && this.state.assigning_dependency_index !== index) {
                    this.state.schedules[this.state.assigning_dependency_index].toggleDependency(index)
                    this.setState({})
                }
            }}>
                <td>
                    <div style={{ 'display': 'flex', 'flexDirection': 'column', 'gap': '2px' }}>
                        <Button size="sm" id={'schedule-up-' + index} disabled={index === 0}
                            onClick={(e) => {
                                e.stopPropagation()
                                this.swapSchedules(index, index - 1)
                                document.getElementById('schedule-up-' + (index - 1)).focus()
                            }}>
                            <IoIosArrowUp style={{ 'fontSize': '10pt' }} />
                        </Button>
                        <Button size="sm" id={'schedule-down-' + index} disabled={index === this.state.schedules.length - 1}
                            onClick={(e) => {
                                e.stopPropagation()
                                this.swapSchedules(index, index + 1)
                                document.getElementById('schedule-down-' + (index + 1)).focus()
                            }}>
                            <IoIosArrowDown style={{ 'fontSize': '10pt' }} />
                        </Button>
                    </div>
                </td>
                <td>

            <Input
                    value={schedule.short_description}
                    onChange={(e) => {
                        const schedules = this.state.schedules
                        schedules[index].short_description = e.target.value

                        this.setState({
                            'schedules': schedules,
                        })
                    }} /></td>
                <td>
                    <CustomDropDownView
                        toggleLabel={(schedule.sign_ids || []).length === 0
                            ? '—'
                            : (() => {
                                const selected = (this.state.quote?.signs || [])
                                    .filter(s => (schedule.sign_ids || []).includes(s.id))
                                const totalQty = selected.reduce((sum, s) => sum + (parseFloat(s.quantity) || 0), 0)
                                const label = selected.map(s => s.given_id).join(', ')
                                const truncated = label.length > 42 ? label.slice(0, 42) + '…' : label
                                return `${truncated} (${totalQty})`
                            })()
                        }
                        toggleStyle={{ 'width': '100%', 'overflow': 'hidden', 'textOverflow': 'ellipsis', 'whiteSpace': 'nowrap' }}
                        size="sm" color="secondary"
                        view={(this.state.quote?.signs || []).map(s => {
                            const checked = (schedule.sign_ids || []).includes(s.id)
                            const label = [s.given_id, s.type?.label].filter(Boolean).join(' ')
                            return (
                                <DropdownItem key={s.id} toggle={false}
                                    onClick={() => {
                                        const schedules = this.state.schedules
                                        schedules[index].sign_ids = checked
                                            ? (schedules[index].sign_ids || []).filter(id => id !== s.id)
                                            : [...(schedules[index].sign_ids || []), s.id]
                                        this.setState({ 'schedules': schedules })
                                    }}
                                >
                                    <Input type="checkbox" checked={checked} onChange={() => {}}
                                        style={{ 'marginRight': '6px' }}
                                    />
                                    {label} ({s.quantity})
                                </DropdownItem>
                            )
                        })}
                    />
                </td>
                <td><Button onClick={() => {
                    if (this.state.assigning_dependency_index === index) {
                        this.setState({
                            'assigning_dependency_index': -1,
                        })
                    } else {
                        this.setState({
                            'assigning_dependency_index': index,
                        })
                    }
                }} className={this.state.assigning_dependency_index === index ? "selected" : ""}
                ariaPressed={this.state.assigning_dependency_index === index ? "true" : "false"}
                >{this.state.assigning_dependency_index !== index ? "Dependency" : "Selected"} {this.reducedDependencies(index).map((x) => x+1).join(" ")}</Button></td>
                <td>{this.renderMaterialsPicker(schedule, index)}</td>
                <td>{this.renderDropDown('Equip', schedule.equip,
                    EQUIPMENT_LIST, (value, j) => {
                    const schedules = this.state.schedules
                    schedules[index].equip = value

                    this.setState({
                        'schedules': schedules,
                    })
                })}</td>
                <td>{this.renderDropDown('Process', schedule.process,
                    EQUIPMENT_PROCESSES[schedule.equip] || ['Other'], (value, j) => {
                    const schedules = this.state.schedules
                    schedules[index].process = value

                    this.setState({
                        'schedules': schedules,
                    })
                })}</td>
                <td>{this.renderDropDown('Priority', schedule.getPriorityString(),
                        Object.entries(Priority).map((item) => item[0]).reverse(),
                    (value, j) => {
                        const schedules = this.state.schedules
                        schedules[index].setPriority(value)
                        this.setState({
                            'schedules': schedules,
                        })
                    }
                )}</td>
                <td>{this.renderDropDown('Assignee', schedule.assign_to,
                    [...getSortedAssignTo(this.state.assign_to, schedule.equip), 'Other'], (value, j) => {
                    const schedules = this.state.schedules
                    schedules[index].assign_to = value

                    this.setState({
                        'schedules': schedules,
                    })
                }, {normalize: TextNormalization.Whitespace})}</td>
                <td>
                    <NumberTextField
                        showDigitsKeyPad={this.state.account.settings.numbers_calculator_show}
                        style={{
                            'textAlign': 'right',
                        }}
                        value={schedule.human_expected_duration_minutes}
                        onChange={(e) => {
                            const schedules = this.state.schedules
                            schedules[index].human_expected_duration_minutes = e.target.value
                            this.setState({})
                        }}/>
                </td>
                <td><Input
                    type='checkbox' checked={schedule.is_complete}
                    onChange={(e) => {
                        // const schedules = this.state.schedules
                        // schedules[index].end_time = schedules[index].is_complete ? null : new Date()
                        // schedules[index].is_complete = !schedules[index].is_complete

                        // this.setState({
                        //     'schedules': schedules,
                        // })
                    }} />
                    {schedule.end_time ? <Label style={{
                        'marginLeft': '10px',
                    }}>{dateFormat(schedule.end_time, 'mm/dd/yyyy h:MM TT')}</Label> : '' }
                    {
                        schedule.end_time && schedule.start_time
                            ? <Label style={{
                                'marginLeft': '10px',
                            }}>{((new Date(schedule.end_time) - new Date(schedule.start_time)) / (60 * 1000)).toFixed(1)} M</Label>
                            : ''
                    }
                </td>
                <td><Input
                    type='checkbox' checked={schedule.premature_release}
                    onChange={(e) => {
                        const schedules = this.state.schedules
                        schedules[index].premature_release = !schedules[index].premature_release

                        this.setState({
                            'schedules': schedules,
                        })
                    }} /></td>
                <td
                    style={{
                        'min-width': '150px',
                    }}
                ><Button
                    className='btn btn-copy'
                    onClick={(e) => {
                        const localSettings = LocalSettings.fromStorage()
                        localSettings.copyTask(schedule)
                        this.setState({})
                    }} >Copy Clip Board</Button></td>
                <td><Button
                    className='btn btn-copy'
                    onClick={(e) => {
                        let first = this.state.schedules.slice(0, index + 1)
                        const copy = this.state.schedules[index].copy()
                        copy.id = null
                        first.push(copy)
                        const schedules = first.concat(this.state.schedules.slice(index + 1))
                        schedules.forEach(s => {
                            s.dependency = s.dependency.map(d => d > index ? d + 1 : d)
                        })
                        this.setState({ 'schedules': schedules })
                    }}
                    >Duplicate</Button></td>
                <td><Button color="danger"
                    onClick={(e) => {
                        this.deleteAtRow(index);
                    }}
                    >Delete</Button></td>
            </tr>
        )
    }


    // MARK: View

    render() {
        return (
            <Container>
                {this.props.breadCrumbs(2, this.props.id)}
                <Row>
                    { this.state.quote ?
                        <>
                        {this.renderHeader(this.state.quote.customer_name)}
                        {this.renderHeader(this.state.quote.job_name)}
                        {this.renderHeader(this.state.quote.given_id)}
                        </>
                        : <></>
                    }
                </Row>
                {this.state.quote ?
                    <Row>
                        <Col xs='12' sm='4'>
                            <Label style={{
                                'fontWeight': '450',
                                'fontSize': '16pt',
                            }}>Team</Label>
                            <TeamDropdown
                                {...this.props}
                                quoteId={this.state.quote.id}
                                value={this.state.quote.team_name} />
                        </Col>
                    </Row>
                    : <></>
                }
                <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th style={{'minWidth': '50px'}}></th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>Sign Type-Description</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '160px'}}>Sign</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '130px'}}>Dependency</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '160px'}}>Materials</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Equip</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Process</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Priority</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '60px'}}>Assignee</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '80px'}}>Time Hours</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '240px'}}>Completion</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '60px'}} onClick={() => {
                                    const isAllTrue = this.state.schedules.map((x) => x.premature_release).reduceRight((l, r) => l && r)
                                    this.setState({
                                        'schedules': this.state.schedules.map((x) => {
                                            x.premature_release = !isAllTrue
                                            return x
                                        })
                                    })
                                }}>Early Release</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.makeRows()}
                    </tbody>
                </Table></Container></Col></Row>
                {this.state.schedules.length > 0 && this.state.quote && (
                    <JobScheduleFlowViewController
                        schedules={this.state.schedules}
                        quote={this.state.quote}
                        id={this.props.id}
                    />
                )}
                <Row
                    className='quote-bottom-bottons-row'
                    style={{'marginBottom': '20px'}}>
                    <Col>
                        <Container>
                            <Button color="primary" onClick={
                                (e) => {
                                    const first = this.state.schedules
                                    const schedule = new Schedule()
                                    schedule.id = null
                                    schedule.order_index = first.length
                                    first.push(schedule)
                                    this.setState({
                                        'schedules': first,
                                    })
                                }} size="lg" className="default-weight purchase-button"
                                >Add</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button color="primary" onClick={
                                (e) => {
                                    const localSettings = LocalSettings.fromStorage()
                                    const tasks = localSettings.pasteTask()
                                    if (tasks.length > 0) {
                                        this.setState({
                                            'schedules': [...this.state.schedules, ...tasks],
                                        })
                                    }
                                }} size="lg" className="default-weight purchase-button"
                                >Paste</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button color="warning" onClick={() => this.suggest()}
                                size="lg" className="default-weight purchase-button"
                                >Suggest</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button color="primary" onClick={() => this.mergeAll()}
                                size="lg" className="default-weight purchase-button"
                                >Merge</Button>
                        </Container>
                    </Col>
                    <Col>
                        <Container>
                            <Button color="success" onClick={(e) => this.save()}
                                size="lg" className="default-weight purchase-button"
                                >Save</Button>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default ProcessSchedulerViewController
